import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CoordinationStatusResponse } from '../../../coordination/coordination-results/models/coordination-status-response';

@Injectable({
    providedIn: 'root',
})
export class ApplicationCoordinationStatusService {
    private _applicationCoordinationStatus$ =
        new BehaviorSubject<CoordinationStatusResponse | null>(null);

    constructor() {}

    public readonly applicationCoordinationStatus$: Observable<CoordinationStatusResponse | null> =
        this._applicationCoordinationStatus$.asObservable();

    /**
     * Sets the provided ApplicationCoordinationStatusResponse as the current application status.
     * @param newApplicationStatus The new application status to set.
     */
    setApplicationCoordinationStatus(
        newApplicationStatus: CoordinationStatusResponse,
    ): void {
        this._applicationCoordinationStatus$.next(newApplicationStatus);
    }

    /**
     * Gets the current value of the application status.
     * @returns The current ApplicationCoordinationStatus or null if not set
     */
    getCurrentApplicationCoordinationStatus(): CoordinationStatusResponse | null {
        return this._applicationCoordinationStatus$.value;
    }
}
